import { ReactComponentManifest } from "web/entrypoints/common/setup";
import CollectionBar from "web/react/components/collection-bar/collection-bar";
import FeedControls from "web/react/components/feed-controls/feed-controls";
import FeedGenderSwitch from "web/react/components/feed-gender-switch/feed-gender-switch";
import FeedsSeoContent from "web/react/components/feeds-seo-content/feeds-seo-content";
import FeedsShowMore from "web/react/components/feeds-show-more/feeds-show-more";
import FeedsShowPrevious from "web/react/components/feeds-show-previous/feeds-show-previous";
import FilterContainer from "web/react/components/filter-container/filter-container";
import FilterContainerTop from "web/react/components/filter-container-top/filter-container-top";
import Footer from "web/react/components/footer/footer";
import ProfileHeader from "web/react/components/profile-header/profile-header";
import RelatedRail from "web/react/components/related-rail/related-rail";
import RelatedSearchesRail from "web/react/components/related-searches-rail/related-searches-rail";
import withRedux from "web/react/redux-provider";
import ProductCardSendToAppModal from "web/react/components/product-card-send-to-app-modal/product-card-send-to-app-modal";
import FeedsSeoProfileContents from "web/react/components/feeds-seo-content/feeds-seo-profile-content";
import FeedCountAndSort from "web/react/components/feed-count-and-sort/feed-count-and-sort";
import InfeedProductListCTA from "web/react/components/infeed-product-list-cta/infeed-product-list-cta";
import SendToAppModalContainer from "web/react/components/send-to-app-modal-container/send-to-app-modal-container";

const components: ReactComponentManifest = {
    CollectionBar,
    FeedControls: withRedux(FeedControls),
    FeedGenderSwitch: withRedux(FeedGenderSwitch),
    FeedsSeoContent,
    FeedsSeoProfileContents,
    FeedsShowMore: withRedux(FeedsShowMore),
    FeedsShowPrevious: withRedux(FeedsShowPrevious),
    FilterContainer: withRedux(FilterContainer),
    FilterContainerTop: withRedux(FilterContainerTop),
    Footer,
    ProductCardSendToAppModal: withRedux(ProductCardSendToAppModal),
    ProfileHeader,
    RelatedRail,
    RelatedSearchesRail,
    FeedCountAndSort: withRedux(FeedCountAndSort),
    InfeedProductListCTA,
    SendToAppModalContainer: withRedux(SendToAppModalContainer),
};

export default components;
